import { compose } from 'recompose';
import _property from 'lodash/property';
import _head from 'lodash/head';
import _get from 'lodash/get';
import _keyBy from 'lodash/keyBy';
import { PHONE_TYPES } from '../constants/customer.constants';
import { tget } from '../utils/general'; // Reader Mapping

var accountingInfo = _property('accountingInfo');

var addresses = _property('addresses');

var alternateFirstName = _property('alternateFirstName');

var alternateLastName = _property('alternateLastName');

var alternateName = _property('alternateName');

var streetAddress1 = _property('streetAddress1');

var streetAddress2 = _property('streetAddress2');

var city = _property('city');

var county = _property('county');

var companyName = _property('companyName');

var isActive = _property('isActive');

var businessName = _property('businessName');

var contactInfo = _property('contact');

var createdTime = _property('createdTime');

var customerType = _property('customerType');

var dealerId = _property('dealerId');

var deleted = _property('deleted');

var department = _property('department');

var displayId = function displayId(customerData) {
  return tget(customerData, 'displayId', '');
};

var displayName = _property('displayName');

var employers = _property('employers');

var email = _property('email');

var firstName = _property('firstName');

var middleName = _property('middleName');

var id = _property('id');

var customerId = function customerId(customer) {
  return _get(customer, 'customerID') || _get(customer, 'customerId');
};

var insurancePolicyInfos = _property('insurancePolicyInfos');

var lastName = _property('lastName');

var modifiedTime = _property('modifiedTime');

var oemLoyaltyInfo = _property('oemLoyaltyInfo');

var onHoldReason = _property('onHoldReason');

var parentCompany = _property('parentCompany');

var pointOfContacts = _property('pointOfContacts');

var primaryPhone = _property('primaryPhone');

var references = _property('references');

var sites = _property('sites');

var vehicles = _property('vehicles');

var vip = _property('vip');

var socialSecurityNumber = _property('socialSecurityNumber');

var postalCode = _property('postalCode');

var state = _property('state');

var phones = _property('phones');

var number = _property('number');

var phoneType = _property('phoneType');

var preferredContactType = _property('preferredContactType');

var drivingLicense = _property('setup.sale.licenseNumber');

var drivingLicenseState = _property('setup.sale.state');

var dateOfBirth = _property('dateOfBirth');

var externalSourceInfo = _property('externalSourceInfo');

var vehicleInfo = _property('vehicleInfo');

var mobileNumber = _property('mobileNumber');

var creditLimit = _property('accountingInfo.creditLimit');

var creditLimitBalance = _property('accountingInfo.creditLimitBalance');

var chargeCustomer = _property('accountingInfo.chargeCustomer');

var customerGLAccount = _property('accountingInfo.customerGLAccount');

var taxExempted = _property('taxExempted');

var customerTypeInteger = _property('customerTypeInteger');

var country = _property('country');

var hasVaultInfo = _property('hasVaultInfo');

var taxability = _property('taxability');

var taxExemptNumber = _property('taxExemptNumber');

var reasonForTaxExemption = _property('reasonForTaxExemption');

var addAddress = _property('addAddress');

var addressInfo = _property('addressInfo');

var name = _property('name');

var salutation = _property('salutation');

var suffix = _property('suffix');

var zip = _property('zip');

var street = _property('street');

var requirePO = _property('requirePO');

var status = _property('status');

var rewardInfo = _property('customerRewardsInfos');

var tags = _property('tags');

var alternateEmail = _property('alternateEmail');

var customerGroup = _property('accountingInfo.customerGroup');

var taxInformation = _property('taxInformation');

var taxPercentage = _property('taxPercentage');

var ccpaInfo = _property('ccpaInfo');

var glbaInfo = _property('glbaInfo');

var addressLine1 = _property('line1');

var addressLine2 = _property('line2');

var oemRewardInfos = _property('oemRewardInfos');

var externalId = compose(_property('externalSourceID'), _head, externalSourceInfo);

var customerName = function customerName(customer) {
  var customerFirstName = firstName(customer);
  var customerLastName = lastName(customer);
  if (customerFirstName && customerLastName) return "".concat(customerFirstName, " ").concat(customerLastName);
  if (customerFirstName) return customerFirstName;
  if (customerLastName) return customerLastName;
  return undefined;
};

var getPhoneDetailsByPhoneType = function getPhoneDetailsByPhoneType(customerDetails, type) {
  var phoneDetailsByPhoneType = _keyBy(phones(customerDetails), phoneType);

  return _get(phoneDetailsByPhoneType, type);
};

var getMobilePhoneDetails = function getMobilePhoneDetails(customerDetails) {
  return getPhoneDetailsByPhoneType(customerDetails, PHONE_TYPES.MOBILE);
};

var getHomePhoneDetails = function getHomePhoneDetails(customerDetails) {
  return getPhoneDetailsByPhoneType(customerDetails, PHONE_TYPES.HOME);
};

var getWorkPhoneDetails = function getWorkPhoneDetails(customerDetails) {
  return getPhoneDetailsByPhoneType(customerDetails, PHONE_TYPES.WORK);
};

var defaultServicePricing = _property('setup.service.defaultServicePricing');

var specialLaborPricing = _property('setup.service.specialLaborPricing');

var fax = _property('fax');

var defaultToUnusualSaleOnSO = _property('setup.part.defaultToUnusualSaleOnSO');

var emailServiceUpdates = _property('communicationPreferences.email.serviceUpdates');

var textServiceUpdates = _property('communicationPreferences.text.serviceUpdates');

var generateARStatements = _property('accountingInfo.generateARStatements');

var alternateEmailForAR = _property('accountingInfo.alternateEmailForAR');

var routeNumber = _property('setup.part.routeNumber');

var partForbiddenPaymentMethods = _property('setup.part.forbiddenPaymentMethods');

var READER = {
  defaultServicePricing: defaultServicePricing,
  accountingInfo: accountingInfo,
  customerName: customerName,
  addresses: addresses,
  county: county,
  alternateFirstName: alternateFirstName,
  alternateLastName: alternateLastName,
  alternateName: alternateName,
  businessName: businessName,
  streetAddress1: streetAddress1,
  streetAddress2: streetAddress2,
  city: city,
  companyName: companyName,
  isActive: isActive,
  contactInfo: contactInfo,
  createdTime: createdTime,
  customerType: customerType,
  dealerId: dealerId,
  deleted: deleted,
  department: department,
  displayId: displayId,
  displayName: displayName,
  employers: employers,
  email: email,
  firstName: firstName,
  id: id,
  customerId: customerId,
  insurancePolicyInfos: insurancePolicyInfos,
  lastName: lastName,
  modifiedTime: modifiedTime,
  oemLoyaltyInfo: oemLoyaltyInfo,
  onHoldReason: onHoldReason,
  parentCompany: parentCompany,
  pointOfContacts: pointOfContacts,
  primaryPhone: primaryPhone,
  references: references,
  sites: sites,
  vehicles: vehicles,
  vip: vip,
  socialSecurityNumber: socialSecurityNumber,
  postalCode: postalCode,
  state: state,
  phones: phones,
  number: number,
  phoneType: phoneType,
  preferredContactType: preferredContactType,
  getMobilePhoneDetails: getMobilePhoneDetails,
  getHomePhoneDetails: getHomePhoneDetails,
  getWorkPhoneDetails: getWorkPhoneDetails,
  drivingLicense: drivingLicense,
  middleName: middleName,
  externalId: externalId,
  externalSourceInfo: externalSourceInfo,
  vehicleInfo: vehicleInfo,
  mobileNumber: mobileNumber,
  creditLimit: creditLimit,
  creditLimitBalance: creditLimitBalance,
  chargeCustomer: chargeCustomer,
  customerGLAccount: customerGLAccount,
  taxExempted: taxExempted,
  customerTypeInteger: customerTypeInteger,
  drivingLicenseState: drivingLicenseState,
  dateOfBirth: dateOfBirth,
  country: country,
  hasVaultInfo: hasVaultInfo,
  taxability: taxability,
  taxExemptNumber: taxExemptNumber,
  reasonForTaxExemption: reasonForTaxExemption,
  fax: fax,
  addAddress: addAddress,
  addressInfo: addressInfo,
  name: name,
  salutation: salutation,
  suffix: suffix,
  defaultToUnusualSaleOnSO: defaultToUnusualSaleOnSO,
  zip: zip,
  street: street,
  emailServiceUpdates: emailServiceUpdates,
  textServiceUpdates: textServiceUpdates,
  requirePO: requirePO,
  alternateEmailForAR: alternateEmailForAR,
  generateARStatements: generateARStatements,
  status: status,
  rewardInfo: rewardInfo,
  tags: tags,
  alternateEmail: alternateEmail,
  customerGroup: customerGroup,
  taxInformation: taxInformation,
  taxPercentage: taxPercentage,
  routeNumber: routeNumber,
  partForbiddenPaymentMethods: partForbiddenPaymentMethods,
  ccpaInfo: ccpaInfo,
  glbaInfo: glbaInfo,
  addressLine1: addressLine1,
  addressLine2: addressLine2,
  specialLaborPricing: specialLaborPricing,
  oemRewardInfos: oemRewardInfos
};
export default READER;